import { Document, DocumentType } from '@consigli/types';

export const isDocumentDoubleViewerCapable = (
  document: Document,
): document is Document & { refBlobId: string; refContent: string } =>
  document.type === DocumentType.FINDING &&
  document.refBlobId != null &&
  document.refContent != null;
